import {
  Card,
  CardTitle,
  Top10Percentage,
  Top10PositionRow,
  Top10Rank,
  Top10Symbol,
  Top10Value,
} from "../Factsheet.styled"
import { Top10Position } from "../types"
import { formatCurrency } from "../utils"

interface Top10CardProps {
  positions: Top10Position[]
  currency?: string | null
}

const Top10Card = ({ positions, currency }: Top10CardProps) => {
  return (
    <Card flexDirection="column">
      <CardTitle>Top 10 Equities</CardTitle>
      {positions.map((pos, index) => (
        <Top10PositionRow key={pos.symbol} justifyContent="space-between" alignItems="center">
          <Top10Rank>{index + 1}.</Top10Rank>
          <Top10Symbol title={pos.companyName}>{pos.symbol}</Top10Symbol>
          <Top10Percentage>{pos.percentage.toFixed(1)}%</Top10Percentage>
          <Top10Value>{formatCurrency(pos.exposure, currency)}</Top10Value>
        </Top10PositionRow>
      ))}
      {positions.length === 0 && <span>No positions</span>}
    </Card>
  )
}

export default Top10Card
